<template>
  <form :action="this.$route('web.search')" method="GET">
    <div
      class="mx-auto flex w-full items-center justify-center gap-3 max-lg:relative max-lg:max-w-lg max-lg:flex-col lg:justify-start"
    >
      <v-dropdown-sm class="flex-1">
        <template v-slot:trigger>
          <button
            type="button"
            class="flex w-full items-center justify-center rounded-full px-4 py-2 font-medium text-black-50 hover:bg-green-10"
          >
            <div class="h-6 w-6">
              <img
                src="/assets/images/countries/si.svg"
                v-if="currentCountry == 'Slovenija'"
                alt=""
                class="h-6 w-6 rounded-full"
              />
              <img
                src="/assets/images/countries/hr.svg"
                v-if="currentCountry == 'Hrvaška'"
                alt=""
                class="h-6 w-6 rounded-full"
              />
            </div>
            <div>
              <v-icon icon="chevron-down" class="ml-2" size="5"></v-icon>
            </div>
          </button>
        </template>
        <template v-slot:content>
          <div class="flex flex-col gap-3.5">
            <a href="/drzava/svn" class="hover:text-green"> Slovenija </a>
            <a href="/drzava/hrv" class="hover:text-green"> Hrvaška </a>
          </div>
        </template>
      </v-dropdown-sm>

      <v-dropdown @open="onOpenRegionDropdown" ref="regionDropdown">
        <template v-slot:trigger>
          <a class="button button--white has-location">
            <v-icon icon="map-pin"></v-icon>
            {{ regionOption?.region ?? "Regija" }}

            <div
              v-if="regionOption != null"
              class="-mr-3 cursor-pointer text-black-78"
            >
              <v-icon
                icon="close"
                size="4"
                @click="regionOption = null"
              ></v-icon>
            </div>
          </a>
        </template>
        <template v-slot:content>
          <div class="relative flex items-center">
            <label
              for="region"
              class="absolute left-0 top-0 z-10 hidden w-full cursor-pointer items-center rounded-full py-5 font-medium text-black-40 md:px-10 lg:flex"
              :class="'h-[50px] rounded-full px-5 py-0 pb-7 pt-2.5 text-xxs ring-1 ring-inset ring-gray md:px-8'"
              @click="openRegion"
            >
              <div class="overflow-hidden text-ellipsis whitespace-nowrap">
                Regija
              </div>

              <div
                v-if="regionOption != null"
                class="absolute right-4 top-1/2 z-10 -translate-y-1/2 cursor-pointer text-black-78"
              >
                <v-icon
                  icon="close"
                  size="5"
                  @click="regionOption = null"
                ></v-icon>
              </div>
            </label>

            <v-select
              class="v-select--sm v-select--inline w-full font-medium"
              :options="regions"
              placeholder=""
              v-model="regionOption"
              label="region"
              @option:selected="onRegionSelect"
              ref="region"
              id="region"
              :name="'region'"
            >
              <template v-slot:no-options>
                Za ta iskalni niz ni zadetkov.
              </template>
            </v-select>
            <input
              type="hidden"
              name="region"
              :value="regionOption == null ? '' : regionOption.region"
            />
          </div>
        </template>
      </v-dropdown>

      <v-dropdown @open="onOpenLocationDropdown" ref="locationDropdown">
        <template v-slot:trigger>
          <a class="button button--white has-location">
            <v-icon icon="map-pin"></v-icon>
            <!-- {{ reactiveLocation }} -->
            {{ locationOption?.custom_label ?? "Lokacija" }}

            <div
              v-if="locationOption != null"
              class="-mr-3 cursor-pointer text-black-78"
            >
              <v-icon
                icon="close"
                size="4"
                @click="locationOption = null"
              ></v-icon>
            </div>
          </a>
        </template>
        <template v-slot:content>
          <div class="relative flex items-center">
            <label
              for="location"
              class="absolute left-0 top-0 z-10 hidden w-full cursor-pointer items-center rounded-full py-5 font-medium text-black-40 md:px-10 lg:flex"
              :class="'h-[50px] rounded-full px-5 py-0 pb-7 pt-2.5 text-xxs ring-1 ring-inset ring-gray md:px-8'"
              @click="openLocation"
            >
              <div class="overflow-hidden text-ellipsis whitespace-nowrap">
                Lokacija
              </div>

              <div
                v-if="locationOption != null"
                class="absolute right-4 top-1/2 z-10 -translate-y-1/2 cursor-pointer text-black-78"
              >
                <v-icon
                  icon="close"
                  size="5"
                  @click="locationOption = null"
                ></v-icon>
              </div>
            </label>

            <v-select
              class="v-select--sm v-select--inline w-full font-medium"
              :options="locationsData"
              placeholder=""
              v-model="locationOption"
              label="custom_label"
              @search="debouncedFetchLocations"
              @option:selected="onLocationSelect"
              ref="location"
              id="location"
              :name="'location'"
            >
              <template v-slot:no-options>
                Za ta iskalni niz ni zadetkov.
              </template>
            </v-select>
            <input
              type="hidden"
              name="location"
              :value="locationOption == null ? '' : locationOption.value"
            />
          </div>
        </template>
      </v-dropdown>

      <v-dropdown ref="rentOrBuyDropdown">
        <template v-slot:trigger>
          <a
            class="button button--white hidden shadow lg:flex"
            v-if="rentOrBuyPlaceholder"
          >
            <v-icon :icon="rentOrBuyPlaceholder.icon"></v-icon>
            {{ rentOrBuyPlaceholder.label }}
          </a>
        </template>
        <template v-slot:content>
          <div class="grid grid-cols-2 gap-5">
            <div v-for="(option, index) in rentOrBuyOptions">
              <v-form-radio
                name="rent_or_buy"
                :id="'rent_or_buy_' + index"
                :label="option.label"
                :value="option.value"
                v-model="rentOrBuyValue"
                :fixed-height="true"
              >
                <template v-slot:icon>
                  <v-icon :icon="option.icon" size="5" class="mr-2"></v-icon>
                </template>
              </v-form-radio>
            </div>
          </div>
        </template>
      </v-dropdown>

      <v-dropdown ref="realestateTypeDropdown">
        <template v-slot:trigger>
          <a
            class="button button--white hidden shadow lg:flex"
            v-if="realestateTypePlaceholder"
          >
            <v-icon :icon="realestateTypePlaceholder.icon"></v-icon>
            {{ realestateTypePlaceholder.label }}
          </a>
        </template>
        <template v-slot:content>
          <div class="grid grid-cols-2 gap-5">
            <div v-for="(option, index) in realestateTypeOptions">
              <v-form-radio
                name="realestate_property_type"
                :id="'realestate_property_type_' + index"
                :label="option.label"
                :value="option.value"
                v-model="realestateTypeValue"
                :fixed-height="true"
              >
                <template v-slot:icon>
                  <v-icon :icon="option.icon" size="5" class="mr-2"></v-icon>
                </template>
              </v-form-radio>
            </div>
          </div>
        </template>
      </v-dropdown>

      <v-dropdown ref="priceDropdown">
        <template v-slot:trigger>
          <a class="button button--white hidden shadow lg:flex">
            <v-icon icon="euro"></v-icon>
            <template v-if="reactivePriceFrom && !reactivePriceTo">
              Od {{ reactivePriceFrom }}
            </template>

            <template v-if="!reactivePriceFrom && reactivePriceTo">
              Do {{ reactivePriceTo }}
            </template>

            <template v-if="reactivePriceFrom && reactivePriceTo">
              {{ reactivePriceFrom }} - {{ reactivePriceTo }}
            </template>

            <template v-if="!reactivePriceFrom && !reactivePriceTo">
              &#8734;
            </template>
            € {{ rentOrBuy == "miete" ? "mesec" : "" }}
          </a>
        </template>
        <template v-slot:content>
          <div class="flex items-center gap-3.5">
            <div>
              <v-form-input
                id="price_from"
                label="Od min"
                type="number"
                :value="reactivePriceFrom"
                v-model="reactivePriceFrom"
                append-text="€"
              ></v-form-input>
            </div>
            <div>
              <v-form-input
                id="price_to"
                label="Do max"
                type="number"
                :value="reactivePriceTo"
                v-model="reactivePriceTo"
                append-text="€"
              ></v-form-input>
            </div>
          </div>

          <div class="mt-5 flex justify-center gap-5">
            <button
              type="button"
              class="button button--gray w-36"
              @click="resetPrice"
            >
              <v-icon icon="reset"></v-icon>
              Ponastavi
            </button>

            <button type="button" class="button w-36" @click="confirmPrice">
              Potrdi
              <v-icon icon="check"></v-icon>
            </button>
          </div>
        </template>
      </v-dropdown>

      <button class="button hidden lg:flex" type="submit">
        <v-icon icon="loupe-list"></v-icon>
        <span>Prikaži rezultate</span>
      </button>
    </div>
  </form>
</template>

<script>
import debounce from "lodash/debounce";

export default {
  name: "SearchFields",

  props: {
    region: {
      type: String,
      default: null,
    },
    location: {
      type: String,
      default: null,
    },
    rentOrBuy: {
      type: String,
      default: null,
    },
    propertyType: {
      type: String,
      default: null,
    },
    priceFrom: {
      type: [String, Number],
      default: null,
    },
    priceTo: {
      type: [String, Number],
      default: null,
    },
    i18n: {
      type: Object,
      required: true,
    },
    unparsedEnums: {
      type: Object,
      required: true,
    },
    currentCountry: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      reactiveLocation: "",
      reactivePriceFrom: "",
      reactivePriceTo: "",
      reactiveRentOrBuy: "",
      rentOrBuyValue: "kauf",
      reactiveRealestateType: "",
      realestateTypeValue: "wohnung",
      locationOption: "",
      hideLocationLabel: false,
      regions: [],
      locationsData: [],
      regionOption: null,
    };
  },

  computed: {
    rentOrBuyOptions() {
      return this.parseEnums("vermarktungsart");
    },

    rentOrBuyPlaceholder() {
      this.$refs.rentOrBuyDropdown
        ? (this.$refs.rentOrBuyDropdown.show = false)
        : null;

      return this.rentOrBuyOptions.find(
        (option) => option.value === this.rentOrBuyValue
      );
    },

    realestateTypeOptions() {
      return this.parseEnums("objektart");
    },

    realestateTypePlaceholder() {
      this.$refs.realestateTypeDropdown
        ? (this.$refs.realestateTypeDropdown.show = false)
        : null;

      if (this.realestateTypeValue === "") {
        return {
          label: "Tip nepremičnine",
          icon: "apartment",
        };
      }

      return this.realestateTypeOptions.find(
        (option) => option.value === this.realestateTypeValue
      );
    },
  },

  methods: {
    onOpenLocationDropdown() {
      setTimeout(() => {
        this.openLocation();
      }, 50);
    },

    // This needs to be global or mixin where v-select is used for locations
    openLocation() {
      // Access the Vue Select instance using the ref
      const selectComponent = this.$refs.location;

      // Check if the Vue Select instance exists and is defined
      if (selectComponent) {
        selectComponent.$refs.search.focus();
      }
    },

    onLocationSelect(selectedLocation) {
      this.reactiveLocation = selectedLocation.custom_label;
      this.$refs.locationDropdown.show = false;
      this.setRegion();
    },

    onOpenRegionDropdown() {
      setTimeout(() => {
        this.openRegion();
      }, 50);
    },

    // This needs to be global or mixin where v-select is used for locations
    openRegion() {
      // Access the Vue Select instance using the ref
      const selectComponent = this.$refs.region;

      // Check if the Vue Select instance exists and is defined
      if (selectComponent) {
        selectComponent.$refs.search.focus();
      }
    },

    onRegionSelect() {
      this.$refs.regionDropdown.show = false;
      this.clearLocations();
    },

    resetPrice() {
      this.reactivePriceFrom = "";
      this.reactivePriceTo = "";
    },
    confirmPrice() {
      this.$refs.priceDropdown.show = false;
    },

    parseEnums(key) {
      let specificEnums = [];

      Object.values(this.unparsedEnums).forEach((enumGroup) => {
        if (enumGroup.group == key) {
          Object.keys(enumGroup.values).forEach((enumGroupValueKey) => {
            specificEnums.push({
              value: enumGroupValueKey,
              label: enumGroup.values[enumGroupValueKey],
              icon: this.i18n[enumGroupValueKey]
                ? this.i18n[enumGroupValueKey].icon
                : "",
            });
          });
        }
      });

      return specificEnums;
    },

    clearLocations() {
      this.locationsData = [];
      this.locationOption = null;
      this.reactiveLocation = "Lokacija";
    },

    setRegion() {
      this.regionOption = {
        region: this.locationOption.region,
      };
    },

    fetchRegions() {
      axios
        .get(this.$route("api.regions"))
        .then((response) => {
          const regions = response.data.data;
          this.regions = regions;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    debouncedFetchLocations: debounce(function (value) {
      return this.fetchLocations(value);
    }, 500),

    fetchLocations: async function (value, region) {
      if (value === "") {
        // this.locationsData = [];
        return;
      }

      try {
        const response = await axios.get(this.$route("api.locations"), {
          params: {
            region: region ? region : this.regionOption?.region,
            search: value,
          },
        });
        let locations = response.data.data;
        this.locationsData = locations.map((location) => {
          return {
            value: location["code"],
            custom_label: location["location"],
            region: location["region"],
          };
        });
      } catch (error) {
        console.log(error);
      } finally {
        // Ensure loading(false) is defined
        // this.loading(false);
      }
    },
  },

  mounted() {
    const _self = this;

    (async () => {
      // Fetch locations and wait for function to finish and then continue
      await _self.fetchLocations(null, _self.region);

      _self.locationOption = _self.locationsData.find(
        (loc) => loc.value === _self.location
      );

      _self.reactiveLocation = _self.locationOption?.custom_label ?? null;
    })();

    if (this.region) {
      this.regionOption = {
        region: this.region,
      };
    } else {
      this.regionOption = null;
    }

    this.reactivePriceFrom = this.priceFrom;
    this.reactivePriceTo = this.priceTo;

    this.reactiveRentOrBuy = this.rentOrBuyOptions.find(
      (option) =>
        option.value === (this.rentOrBuy ? this.rentOrBuy : this.rentOrBuyValue)
    );

    this.rentOrBuyValue = this.reactiveRentOrBuy.value;

    this.reactiveRealestateType = this.realestateTypeOptions.find(
      (option) =>
        option.value ===
        (this.propertyType ? this.propertyType : this.realestateTypeValue)
    );

    this.realestateTypeValue = this.reactiveRealestateType.value;

    this.fetchRegions();
  },
};
</script>
